import type { ReactNode } from 'react';

type Props = { message: ReactNode };

export const EmptyMessage: React.FC<Props> = ({ message }: Props) => {
  return (
    <div className="flex h-48 w-full items-center justify-center rounded-lg bg-gray-200">
      <div className="flex flex-col">
        <span className="justify-center text-center">{message}</span>
      </div>
    </div>
  );
};
